/** @jsxImportSource @emotion/react */

import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { Button } from '@mui/material'
import { FC } from 'react'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import * as commonClasses from './styles'

interface IProps {
  itemName: string
  areItemsToDelete?: boolean
  onAddItem?: () => void
  onCancel?: () => void
  onBatchDelete?: () => void
  disabled?: boolean
}

export const TableButtons: FC<IProps> = ({
  onAddItem,
  onCancel,
  onBatchDelete,
  itemName,
  areItemsToDelete,
  disabled,
}) =>
  areItemsToDelete ? (
    <div css={commonClasses.actionButtons}>
      <Button variant="outlined" fullWidth color="blue" size="large" onClick={onCancel} disabled={disabled}>
        Cancel
      </Button>
      <Button variant="outlined" fullWidth color="red" size="large" onClick={onBatchDelete} disabled={disabled}>
        <TrashIcon />
        Batch Delete
      </Button>
    </div>
  ) : (
    <Button
      variant="outlined"
      css={commonClasses.addButton}
      fullWidth
      color="blue"
      size="large"
      onClick={onAddItem}
      disabled={disabled}
    >
      Add {itemName}
      <AddRoundedIcon css={commonClasses.iconPlus} />
    </Button>
  )

export default TableButtons
